export default {

    updateFields(fields){

        //TODO: migrated as-is from adobe launch for safety. Needs refactor.
        let utmFieldList = [
            "UTM_Campaign__c",
            "UTM_Term__c",
            "UTM_Content__c",
            "UTM_Source__c",
            "UTM_Medium__c",
            "UTM_Campaign_Number__c",
            "UTM_Last_Campaign_Session__c",
            "UTM_Session__c",
            "UTM_Referral_Sources__c",
            "UTM_Session_Date__c",
            "UTM_Domain__c"
        ]

        //Set Variables from campaignHist cookie
        let campaignInfo = (decodeURIComponent(this.getCookie('UTMcampaignHist'))).split(',');
        fields.UTM_Campaign__c = campaignInfo[0] || 'None';
        fields.UTM_Term__c = campaignInfo[3] || '';
        fields.UTM_Content__c = campaignInfo[4] || 'None';

        //Set Variables from UTMReferralSources cookie
        let sourceInfo = (decodeURIComponent(this.getCookie('UTMReferralSources'))).split('|');
        fields.UTM_Source__c = sourceInfo[0] || 'None';
        fields.UTM_Medium__c = sourceInfo[1] || 'None';

        //Set Campaign and Session Count
        fields.UTM_Campaign_Number__c = this.getCookie('UTMCampaignNum') || '0';
        fields.UTM_Last_Campaign_Session__c = this.getCookie('UTMLastCampaignSession') || '1';
        fields.UTM_Session__c = this.getCookie('UTMSessionCount') || '1';
        if (isNaN(fields.UTM_Session__c)){fields.UTM_Session__c = 1;}

        //Set Program Codes
        let programString = ""
        if (this.getCookie('UTMprogramHist')){
            programString = decodeURIComponent(this.getCookie('UTMprogramHist'));
        }
        fields.UTM_Referral_Sources__c = programString || 'None';

        //Set Fields from DOM
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + "-" + mm + "-" + dd;

        fields.UTM_Session_Date__c = today;
        fields.UTM_Domain__c = window.location.hostname;

        for (var i = 0; i < utmFieldList.length; i++) {
            fields[utmFieldList[i]] = fields[utmFieldList[i]].split("+").join(" ")
        }

        fields.UTM_Medium__c = this.getMedium(fields, fields.UTM_Medium__c)

    },
    getMedium(fields, medium){
        let	mediumMap = {
            "direct" : "Direct Traffic",
            "organic" : "Organic Search",
            "referral" : "Referral Traffic"
        }
        let altField = "Web_Referral__c",
            source =  fields.UTM_Medium__c.split('+').join(' ') + "|" + fields.UTM_Source__c.split('+').join(' ');
        if(Object.keys(mediumMap).includes(medium)){
            fields.UTM_Source__c = "Corpwebsite";

            fields[altField] = source;

            return mediumMap[medium];
        }else{
            return medium
        }
    },
    getCookie(name) {
        name += "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ""
    }
}


